'use client'
import { createContext, PropsWithChildren, useContext } from 'react'
import { Address } from 'viem'
import { useLocalStorage } from '@hooks/useWebStorage.hook.ts'

type ContextState = {
  favourites: Address[]
  addFavourite: (value: Address) => void
  removeFavourite: (value: Address) => void
}

const context = createContext<ContextState>({} as ContextState)

export function FavouriteProjectsProvider({ children }: PropsWithChildren) {
  const [favourites, setFavourites] = useLocalStorage<Address[]>('favourite-projects', [])

  const addFavourite = (value: Address) => {
    setFavourites([...favourites, value])
  }

  const removeFavourite = (value: Address) => {
    setFavourites(favourites.filter((favourite) => favourite !== value))
  }

  return (
    <context.Provider value={{ favourites, addFavourite, removeFavourite }}>
      {children}
    </context.Provider>
  )
}

export const useFavouriteProjects = () => useContext(context)
